module.exports = __webpack_public_path__ + "static/media/01.bff44229.mp3";